
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { User } from 'lucide-react';
import PersonalInfoSection from '../dashboard/profile-sections/PersonalInfoSection';

interface CandidateCardProps {
  candidate: {
    id: string;
    first_name: string | null;
    last_name: string | null;
    job_seeker_profiles: {
      headline: string | null;
      location: string | null;
      current_position: string | null;
      years_of_experience: string | null;
    };
  };
}

const CandidateCard: React.FC<CandidateCardProps> = ({ candidate }) => {
  const navigate = useNavigate();
  
  const fullName = [candidate.first_name, candidate.last_name]
    .filter(Boolean)
    .join(' ') || 'Anonymous User';

  const viewProfile = () => {
    // In a real app, this would navigate to a candidate profile page
    alert(`View detailed profile of ${fullName}`);
    // navigate(`/candidate/${candidate.id}`);
  };
  
  return (
    <Card className="bg-forest border border-mint/30 overflow-hidden hover:border-mint/60 transition-colors">
      <CardHeader className="bg-forest-light p-4 flex flex-row items-center gap-3">
        <div className="bg-mint/20 p-2 rounded-full">
          <User className="h-6 w-6 text-mint" />
        </div>
        <div className="flex-1">
          <h3 className="text-white font-medium">{fullName}</h3>
          <p className="text-white/70 text-sm">{candidate.job_seeker_profiles?.current_position || 'No position'}</p>
        </div>
      </CardHeader>
      <CardContent className="p-4 space-y-4">
        <PersonalInfoSection 
          headline={candidate.job_seeker_profiles?.headline} 
          location={candidate.job_seeker_profiles?.location}
        />
        
        <div className="pt-2 flex flex-col gap-2 text-sm">
          <div className="flex gap-2">
            <span className="text-white/70">Experience:</span>
            <span className="text-white">{candidate.job_seeker_profiles?.years_of_experience || 'Not specified'}</span>
          </div>
        </div>
        
        <Button 
          className="w-full mt-2 bg-mint text-forest hover:bg-mint/80"
          onClick={viewProfile}
        >
          View Profile
        </Button>
      </CardContent>
    </Card>
  );
};

export default CandidateCard;
